<div class="top-nav">
  <div class="container">
    <div class="row">
      <div class="col-6 col-lg-2">
        <a [routerLink]="['/dashboard']" (click)="hamburger.classList.remove('is-active')">
          <img style="border: none;" src="../../../assets/icon/tchek-blue.svg" width="101px" height="27px" alt="">
        </a>
      </div>
      <div class="col-lg-10 d-none d-lg-flex menu-nav">
        <a class="btn-nav" [ngClass]="{'active': page === '/dashboard'}" [routerLink]="['dashboard']">
          <img src="../../../assets/icon/car-parking.svg">
          <span i18n="header|@@scans">Scans</span>
        </a>
        <div class="v-rule"
          *ngIf="isSuperAdmin || companyname === 'pld'|| companyname === 'Tscan'|| companyname === 'Europcar'"></div>
        <a class="btn-nav" *ngIf="isSuperAdmin|| companyname === 'pld'|| companyname === 'Europcar'"
          [ngClass]="{'active': page ==='/params'}" [routerLink]="['params']">
          <img src="../../../assets/icon/single-01.svg">
          <span i18n="header|@@profile">Profil</span>
        </a>
        <div *ngIf="isSuperAdmin" class="v-rule"></div>
        <a class="btn-nav" [ngClass]="{'active': page ==='/monitoring'}" [routerLink]="['monitoring']"
          *ngIf="isSuperAdmin">
          <img src="../../../assets/icon/settings-gear-65.svg">
          <span i18n="header|@@monitor">Monitoring</span>
        </a>
        <div class="v-rule" *ngIf="isSuperAdmin || isAdmin"></div>
        <a *ngIf="isSuperAdmin || isAdmin" class="btn-nav" [ngClass]="{'active': page === '/parameters'}"
          [routerLink]="['parameters']">
          <img src="../../../assets/icon/settings-gear-65.svg">
          <span i18n="header|@@settings">Paramétrage</span>
        </a>
        <div class="v-rule" *ngIf="isSuperAdmin"></div>
        <a class="btn-nav" *ngIf="isSuperAdmin" [ngClass]="{'active': page === '/detection'}"
          [routerLink]="['detection']">
          <img src="../../../assets/icon/artificial-intelligence.svg">
          <span i18n="header|@@detection">Détection</span>
        </a>
        <div class="v-rule" *ngIf="isSuperAdmin "></div>
        <a class="btn-nav" *ngIf="isSuperAdmin" [ngClass]="{'active': page === '/notif'}" href="">
          <img src="../../../assets/icon/bell.svg">
          <span i18n="header|@@notifications">Notifications</span>
        </a>
        <div class="v-rule"></div>
        <a class="btn-nav" [ngClass]="{'active': page === '/support'}" [routerLink]="['support']">
          <i class="fa fa-question-circle" aria-hidden="true"></i>
          <span i18n="header|@@support">Support</span>
        </a>
        <div *ngIf="isSuperAdmin || currentUser === 'hmg'" class="v-rule"></div>
        <a *ngIf="isSuperAdmin || currentUser === 'hmg'" class="btn-nav" [ngClass]="{'active': page === '/lastscan'}"
          [routerLink]="['lastscan']">
          <i class="fa fa-desktop" aria-hidden="true"></i>
          <span i18n="header|@@screen">Écran</span>
        </a>
        <div class="v-rule"></div>
        <a class="btn-nav ml-1" [ngClass]="{'active': page === '/vinscanner'}" [routerLink]="['vinscanner']">
          <i class="fa fa-qrcode" aria-hidden="true"></i>
          <span i18n="header|@@vinscanner">VIN Scanner</span>
        </a>
      </div>
      <div class="col-6 d-block d-lg-none menu-collapsed-nav">
        <button id='subMenue' #hamburger class="hamburger hamburger--squeeze" type="button"
          (click)="hamburger.classList.toggle('is-active')">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>

      <div [ngClass]="{'d-block': hamburger.classList.contains('is-active'),
      'd-none': !hamburger.classList.contains('is-active')}" class="col-12 d-lg-none">

        <div class="row menu-row menu-nav">
          <a class="btn-nav" (click)="hamburger.classList.remove('is-active')"
            [ngClass]="{'active': page === '/dashboard'}" [routerLink]="['dashboard']">
            <img src="../../../assets/icon/car-parking.svg">
            <span i18n="header|@@scans">Scans</span>
          </a>
        </div>
        <div class="row menu-row menu-nav">
          <a class="btn-nav" (click)="hamburger.classList.remove('is-active')" [ngClass]="{'active': page ==='/params'}"
            [routerLink]="['params']">
            <img src="../../../assets/icon/single-01.svg">
            <span i18n="header|@@profile">Profil</span>
          </a>
        </div>
        <div class="row menu-row menu-nav" *ngIf="isSuperAdmin">
          <a class="btn-nav" (click)="hamburger.classList.remove('is-active')"
            [ngClass]="{'active': page ==='/monitoring'}" [routerLink]="['monitoring']" *ngIf="isSuperAdmin">
            <img src="../../../assets/icon/settings-gear-65.svg">
            <span i18n="header|@@monitor">Monitoring</span>
          </a>
        </div>
        <div class="row menu-row menu-nav" *ngIf="isSuperAdmin || isAdmin">
          <a *ngIf="isSuperAdmin || isAdmin" class="btn-nav" (click)="hamburger.classList.remove('is-active')"
            [ngClass]="{'active': page === '/parameters'}" [routerLink]="['parameters']">
            <img src="../../../assets/icon/settings-gear-65.svg">
            <span i18n="header|@@settings">Paramétrage</span>
          </a>
        </div>
        <div class="row menu-row menu-nav" *ngIf="isSuperAdmin">
          <a class="btn-nav" [ngClass]="{'active': page === '/detection'}" [routerLink]="['detection']">
            <img src="../../../assets/icon/artificial-intelligence.svg">
            <span i18n="header|@@detection">Détection</span>
          </a>
        </div>
        <div class="row menu-row menu-nav">
          <a class="btn-nav" [ngClass]="{'active': page === '/detection'}" [routerLink]="['support']">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
            <span i18n="header|@@support">Support</span>
          </a>
        </div>
        <div class="row menu-row menu-nav">
          <a class="btn-nav" (click)="hamburger.classList.remove('is-active')" [ngClass]="{'active': page === '/notif'}"
            href="">
            <img src="../../../assets/icon/bell.svg">
            <span i18n="header|@@notifications">Notifications</span>
          </a>
        </div>
        <div class="row menu-row menu-nav">
          <a class="btn-nav" (click)="hamburger.classList.remove('is-active')"
            [ngClass]="{'active': page === '/vinscanner'}" [routerLink]="['vinscanner']">
            <i class="fa fa-qrcode" aria-hidden="true"></i>
            <span i18n="header|@@vinscanner">VIN Scanner</span>
          </a>
        </div>
      </div>

    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/header/header.component.html